export type AnimationCompletion = 'finished' | 'cancelled';

export interface FinishableAnimation {
  finished: Promise<unknown>;
}

/**
 * Wait for a Web Animation without allowing a user-initiated cancellation to
 * strand the interaction that started it.
 */
export async function waitForAnimationCompletion(animation: FinishableAnimation | undefined): Promise<AnimationCompletion> {
  if (!animation) {
    return 'finished';
  }

  try {
    await animation.finished;
    return 'finished';
  } catch {
    // Web Animations rejects `finished` when `cancel()` is called. Cancellation
    // is an expected control path when someone dismisses a reveal early.
    return 'cancelled';
  }
}
